import React from 'react';
import styled from 'styled-components';

import { Action } from 'state';
import { colors } from 'theme';
import Field from 'types/Field';
import FieldType from 'types/FieldType';
import Section from 'types/Section';
import SingleSelectFieldForm from './SingleSelectFieldForm';
import MultiSelectFieldForm from './MultiSelectFieldForm';
import NumericFieldForm from './NumericFieldForm';
import TextAreaFieldForm from './TextAreaFieldForm';
import TextFieldForm from './TextFieldForm';

const StyledNestedFieldForm = styled.div`
  margin-left: 1.25rem;
  border-left: solid 2px ${colors.grey_200};
  padding: 1rem;
`;

interface NestedSelectFieldFormProps {
  field: Field;
  section: Section;
  dispatch: (action: Action) => void;
}

const NestedSelectFieldForm: React.FC<NestedSelectFieldFormProps> = ({ section, field, dispatch }) => {
  let fieldForm;

  if (field.input_type === FieldType.SINGLE_SELECT) {
    fieldForm = (
      <SingleSelectFieldForm key={field.uuid} section={section} field={field} nestable={false} dispatch={dispatch} />
    );
  } else if (field.input_type === FieldType.TEXT) {
    fieldForm = <TextFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
  } else if (field.input_type === FieldType.TEXT_AREA) {
    fieldForm = <TextAreaFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
  } else if (field.input_type === FieldType.NUMERIC) {
    fieldForm = <NumericFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
  } else {
    fieldForm = (
      <MultiSelectFieldForm key={field.uuid} section={section} field={field} nestable={false} dispatch={dispatch} />
    );
  }

  return <StyledNestedFieldForm>{fieldForm}</StyledNestedFieldForm>;
};

export default NestedSelectFieldForm;
